/**
 * NoticeList
 */

import Config from '../Config';
import Util from '../Util';
import Template from './Template';
import ParamInfo from './ParamInfo';

class NoticeList {

	private $node: any;

	private $_node: any;

	private _id: string;

	private listId: string;

	private categoryId: string;

	private paramInfo: any;

	constructor( node: any, categoryId?: string ) {
		this.$node = node;
		this._id = this.$node.attr( 'id' );
		this.listId = 'ncCommunityNoticeList';
		this.categoryId = categoryId;
		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();
		this.$_node = jQuery( `<div class="${this.listId} board-notice"></div>` );
		this.$node.append( this.$_node );
	}

	public remove() {
		this.$_node.remove();
	}

	public get() {
		const _param: any = {};
		const _categoryId = this.paramInfo.getParamByKey( 'categoryId' ) || this.categoryId;
		const _query = this.paramInfo.getParamByKey( 'query' );
		const listUrl = Config.noticeList({
			board: Config.board,
		});

		if ( _categoryId ) {
			_param.categoryId = _categoryId;
		}

		if ( _query ) {
			this.$_node.hide();
		}

		const list: any = Util.get( listUrl, 'GET', _param );
		const list$ = Util.from( list );

		list$.subscribe( ( data: any ) => {
			let tmp = '';

            // empty data
			if ( data.length === 0 ) {
				this.remove();
			} else {
				data = Util.convertCamelCase( data );
				tmp = Template.noticeList( data, _categoryId );
				this.$_node.append( tmp );
			}
		}, () => {
			// reject
		});
	}
}

export default NoticeList;
